// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"268":"flickity","284":"matter.pkgd","841":"paper-core"}[chunkId] || chunkId) + "." + {"74":"61c31440880ed244df3d","232":"6550ca6298d357e3597b","268":"deeca817671295bae833","284":"4cec6225d5e89e544195","551":"878b7ba81417246d48da","841":"55dd88acf52b5764a12d"}[chunkId] + ".js";
};